import get from 'lodash/get';

export const defaultApiValue = (apiKey, averageFootprint) => {
  const value = get(averageFootprint, `get_defaults_and_results.${apiKey}`);
  const number = parseFloat(value);
  if (isNaN(number)) {
    return value;
  }
  return number;
};

export const userApiValue = (apiKey, userFootprint, averageFootprint) => {
  let value;
  if (/input_/.test(apiKey)) {
    value = get(userFootprint, `inputs.${apiKey}`);
    if (value === undefined) return defaultApiValue(apiKey, averageFootprint);
  } else if (/result_takeaction/.test(apiKey)) {
    value = get(userFootprint, `compute_takeaction_results.${apiKey}`);
  } else {
    value = get(userFootprint, `compute_footprint.${apiKey}`);
  }

  const number = parseFloat(value);
  if (isNaN(number)) {
    return value;
  }
  return number;
};

export const userApiState = (userFootprint, averageFootprint, relevantApiKeys) =>
  relevantApiKeys.reduce((previous, apiKey) => ({
    ...previous,
    [apiKey]: userApiValue(apiKey, userFootprint, averageFootprint),
  }), {});
